import { updateObject } from "../../util/updateObject";
import * as actionTypes from "./actionTypes";
import {
  initialCreateRegoleData,
  initialSelectedApplicationRule,
} from "./helper";

const initialState = {
  applicationRules: {
    data: [],
    lastUpdated: "",
    loading: false,
  },
  createRegoleData: initialCreateRegoleData,
  selectedApplicationRule: initialSelectedApplicationRule,
  createRegoleLoading: false,
  exportRegoleLoading: false,
};

const setGestioniMessaggiData = (state, action) => {
  return updateObject(state, {
    applicationRules: updateObject(state.applicationRules, {
      [action.key]: action.value,
    }),
  });
};

const setExportRegoleLoading = (state, action) => {
  return updateObject(state, {
    exportRegoleLoading: action.value,
  });
};

const setCreateRegoleData = (state, action) => {
  return updateObject(state, {
    createRegoleData: updateObject(state.createRegoleData, {
      [action.key]: action.value,
    }),
  });
};

const setRegoleLoading = (state, action) => {
  return updateObject(state, {
    createRegoleLoading: action.value,
  });
};

const setCurrentApplicationRule = (state, action) => {
  return updateObject(state, {
    selectedApplicationRule: updateObject(state.selectedApplicationRule, {
      [action.key]: action.value,
    }),
  });
};

const regoleDiApplicazioneReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_REGOLE_DI_APPLICAZIONE_DATA_AND_LOADING:
      return setGestioniMessaggiData(state, action);
    case actionTypes.EXPORT_REGOLE_LOADING:
      return setExportRegoleLoading(state, action);
    case actionTypes.CREATE_REGOLE_DI_APPLICAZIONE_DATA:
      return setCreateRegoleData(state, action);
    case actionTypes.CREATE_UPDATE_DELETE_REGOLE:
      return setRegoleLoading(state, action);
    case actionTypes.GET_CURRENT_APPLICATION_RULE:
      return setCurrentApplicationRule(state, action);
    default:
      return state;
  }
};

export default regoleDiApplicazioneReducer;
